import $ from 'jquery';
import 'sticky-kit/dist/sticky-kit.js';
import {toggleCloudCurrency} from '../helpers';

const {__, _x, _n, _nx} = wp.i18n;

class Dedic {

    constructor() {

        const url = new URL(window.location.href);
        this.Z = url.pathname === '/vydelennyj-server-v-rossii/' || url.pathname === '/dedicated-server-rates-in-russia/';

        this.orderForm = $('.gf-dedic');

        if (!this.orderForm.length) return;

        this.isOfferTypeSale = this.orderForm.hasClass('gf-dedic-server--sale');

        this.orderCount = 1;

        this.serverProps = [
            'ram',
            'storage',
            'raid',
            'ip',
        ];

        this.selectProps = $('.select-js');
        this.servers = $('.server-item');
        this.cartBtn = $('.server-item .cart-btn');
        this.isCurrencyRUB = true;
        this.currency = __('руб.', 'atlex');
        this.month = !this.isOfferTypeSale ? '/мес.' : '';
        this.isFormEu = this.orderForm.hasClass('gf-dedic--eu');
        this.currencyAttr = this.isFormEu ? 'euro' : 'rub';

        this.toggleOrderBtn();
        this.stickyForm();
        this.recalcPrices();
        this.events();
    }

    events() {
        this.selectProps.on('change', this.recalcPrices.bind(this));
        this.cartBtn.on('click', this.recalcCartPrices.bind(this));
        this.cartBtn.on('click', this.toggleOrderBtn.bind(this));
        gform.addAction('gform_input_change', this.recalcPrices.bind(this));
        $(document).on('gform_post_render', this.recalcPrices.bind(this));
    }

    recalcPrices() {
        this.switchCurrency();
        setTimeout(() => {
            toggleCloudCurrency('dedic');
        }, 10)

        this.recalcSelect();
        this.recalcTotal();
        this.recalcCartPrices();
    }

    recalcSelect() {

        if(this.Z) return false;

        this.servers.map((idx, server) => {
            this.serverProps.map(prop => {
                const unit = (prop === 'ram') ? 'GB' : '';
                const options = $(server).find(`.select-${prop}-js option`);

                options.map((idx, option) => {
                    const priceSelected = +$(option).closest('select').find('option:selected').attr(`data-rent-price-${this.currencyAttr}`)

                    let price = +$(option).attr(`data-rent-price-${this.currencyAttr}`);
                    const value = $(option).val();
                    const isSelected = $(option).is(':selected');

                    if (isSelected) {
                        option.textContent = `${value} ${unit}`;
                    } else if (priceSelected <= price) {
                        price = price - priceSelected;
                        price = this.calcExchangePrice(price);
                        option.textContent = `${value} ${unit} (+ ${price} ${this.currency})`;
                    } else if (priceSelected >= price) {
                        price = priceSelected - price;
                        price = this.calcExchangePrice(price);
                        if ((prop === 'storage' && value === 'Добавить накопитель') || (prop === 'storage' && value === 'Add drive')) {
                            if (ATLEX_OBJ.lang === 'ru') {
                                option.textContent = `Убрать накопитель (- ${price} ${this.currency})`;
                            } else {
                                option.textContent = `Remove drive (- ${price} ${this.currency})`;
                            }
                        } else {
                            option.textContent = `${value} ${unit} (- ${price} ${this.currency})`;
                        }
                    }

                })
            })

        });
    }

    stickyForm() {
        const orderWrapper = $('#sticky-order');
        if ($(window).width() > 992) {
            orderWrapper.stick_in_parent({
                offset_top: 40,
                recalc_every: 10
            });
        }
    }

    calcExchangePrice(price) {
        if (this.isCurrencyRUB && this.isFormEu) {
            price = (price * ATLEX_OBJ.exchange_rate.eur).toLocaleString('ru-RU');
        } else if (!this.isCurrencyRUB && this.isFormEu) {
            price = parseInt(price).toLocaleString('en-GB');
        } else {
            price = parseInt(price).toLocaleString('ru-RU');
        }
        return price;
    }

    toggleOrderBtn() {
        const orderBtn = this.orderForm.find('input[type="submit"]');
        const orderResultEl = document.querySelector('.order-result');
        if (orderResultEl) {
            setTimeout(() => {
                const isEmpty = !orderResultEl.hasChildNodes();
                if (isEmpty) {
                    orderBtn.attr('disabled', true);
                } else {
                    orderBtn.attr('disabled', false);
                }
            })
        }
    }

    switchCurrency() {
        if (this.isFormEu) {
            this.isCurrencyRUB = $('.gf-dedic__currency input').is(':checked');

            if (ATLEX_OBJ.lang === 'ru' && this.isCurrencyRUB) {
                this.currency = 'руб.';
            } else if (ATLEX_OBJ.lang === 'ru' && !this.isCurrencyRUB) {
                this.currency = 'евро';
            }

            if (ATLEX_OBJ.lang === 'en' && this.isCurrencyRUB) {
                this.currency = 'rubles';
            } else if (ATLEX_OBJ.lang === 'en' && !this.isCurrencyRUB) {
                this.currency = 'euro';
            }

            if (ATLEX_OBJ.lang === 'ru') {
                this.month = '/мес.'
            } else {
                this.month = '/month'
            }
        } else {
            if (ATLEX_OBJ.lang === 'ru') {
                this.currency = 'руб.';
            } else if (ATLEX_OBJ.lang === 'en') {
                this.currency = 'rubles';
            }

            if (!this.isOfferTypeSale) {
                if (ATLEX_OBJ.lang === 'ru') {
                    this.month = '/мес.'
                } else {
                    this.month = '/month'
                }
            }
        }
    }

    recalcTotal() {
        this.servers.each((idx, server) => {
            let price = 0;

            const priceEl = $(server).find(`.server-price-${this.currencyAttr} .server-price-value`);
            const basePrice = +$(server).find(`.server-basic-price-${this.currencyAttr}`).val();
            const currencyEl = $(server).find(`.server-price-${this.currencyAttr} .price-currency`);
            const optionElements = server.querySelectorAll('option');

            for (const option of optionElements) {
                if ($(option).is(':selected') && $(option).data(`rent-price-${this.currencyAttr}`)) {
                    price = price + parseInt($(option).data(`rent-price-${this.currencyAttr}`));
                }
            }

            price = price + basePrice;

            price = this.calcExchangePrice(price)

            priceEl.text(price);
            currencyEl.text(`${this.currency}${this.month}`)
        })
    }

    recalcCartPrices() {

        if (!this.isFormEu) return false;

        let totalPrice = 0;

        setTimeout(() => {
            const orders = $('.order-result .order-item');
            const totalPriceEl = $(`.total-price-${this.currencyAttr}`);
            orders.each((idx, order) => {
                const priceEl = $(order).find(`.cart-price-${this.currencyAttr}`);
                const currencyEl = priceEl.next('span');

                const price = this.calcExchangePrice(priceEl.data('order-price'));
                totalPrice += priceEl.data('order-price');
                priceEl.text(price);
                currencyEl.text(`${this.currency}${this.month}`)
            })

            totalPrice = this.calcExchangePrice(totalPrice);
            totalPriceEl.find('.cart-total-value').text(totalPrice);
            totalPriceEl.find('.cart-currency').text(`${this.currency}${this.month}`);
        }, 1)

    }

    createOrder() {
        this.recalcPrices();
    }
}

export default Dedic;
